export default "__VITE_ASSET__DHFBvZln__"